export default "__VITE_ASSET__e38dbecb__"